import { createContext } from 'react';
import { ChatActionsNoop } from '@duke-hq/svc-support-web';

export const SupportContextNoop = {
  archive: (_id: string) => {},
  actions: { ...ChatActionsNoop, createStudentContextChat: async () => {} },
};

export const SupportContext = createContext(SupportContextNoop);
